import axios from 'axios'
import { useUserStore } from '@/stores/user'

console.log(import.meta.env.NODE_ENV)

let url = import.meta.env.VITE_BASE_API

const service = axios.create({
  baseURL: url, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 20000, // request timeout
})


// request interceptor
service.interceptors.request.use(
  config => {
    const userStore = useUserStore()
    // do something before request is sent
    // console.log(config, "请求参数")
    // debugger
    if (userStore.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['Authorization'] = getToken()
      if (config.method == 'post') {
        if (config.data instanceof FormData) {
          config.headers['Content-Type'] = 'multipart/form-data'
          config.headers['Accept'] = 'application/json'
          config.data.append('access_token', userStore.token)
        } else {
          config.data ? null : config.data = {}
          config.data['access_token'] = userStore.token
        }
      } else {
        config.params ? null : config.params = {}
        config.params['access_token'] = userStore.token
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
export default service
